var pixValue = 0;
function getPixValue(){
  return pixValue;
}
document.addEventListener("DOMContentLoaded", function(event) {
  
  $(".easyorder-popup-submit-holder>div>a")[0].setAttribute("onclick","sendForm()");
  //%D9%82%D9%84%D8%A7%D8%AF%D8%A9-%D8%AA%D9%8A%D9%81%D8%A7%D9%86%D9%8A
  //.ma/products/solid-mill-%D8%A7%D9%84%D8%B7%D8%A7%D8%AD%D9%88%D9%86%D8%A9-%D8%A7%D9%84%D8%B5%D9%84%D8%A8%D8%A9
//   if(location.href.includes('2-%D9%82%D9%84%D8%A7%D8%AF%D8%A9-%D8%AA%D9%8A%D9%81%D8%A7%D9%86%D9%8A')){
//     $("#AddToCart-product-template").removeClass("d-block");
//     $("#AddToCart-product-template").addClass("d-none");
//     $("#add-order-section").removeClass("d-none");
//      pixValue = "551466225273579";
//   }
//   if(location.href.includes('/collections/%D8%A7%D9%84%D8%A3%D9%83%D8%AB%D8%B1-%D9%85%D8%A8%D9%8A%D8%B9%D8%A7/products/solid-mill-%D8%A7%D9%84%D8%B7%D8%A7%D8%AD%D9%88%D9%86%D8%A9-%D8%A7%D9%84%D8%B5%D9%84%D8%A8%D8%A9')){
//     $("#AddToCart-product-template").removeClass("d-block");
//     $("#AddToCart-product-template").addClass("d-none");
//     $("#add-order-section").removeClass("d-none");
//      pixValue = "551466225273579";
//   }
//    if(location.href.includes('.ma/products/solid-mill-%D8%A7%D9%84%D8%B7%D8%A7%D8%AD%D9%88%D9%86%D8%A9-%D8%A7%D9%84%D8%B5%D9%84%D8%A8%D8%A9')){
//     $("#AddToCart-product-template").removeClass("d-block");
//     $("#AddToCart-product-template").addClass("d-none");
//     $("#add-order-section").removeClass("d-none"); 
//     pixValue = "328716290583979";
//   }
  
  var delayInMilliseconds = 1000; //1 second

setTimeout(function() {
  
var head = document.getElementsByTagName('head')[0];
var linkElement = document.createElement('link');
linkElement.setAttribute('rel', 'stylesheet');
linkElement.setAttribute('type', 'text/css');
linkElement.setAttribute('href', "//ghizlane.ma/cdn/shop/t/1/assets/myStyle.css?v=176395268966549915141603899591");
head.appendChild(linkElement);
}, delayInMilliseconds);

});

function sendForm(){
  var phone = $(".eorder_tooltips>input[type=tel]")[0].value.split("+212 ").join("").split("212 ").join("");
  var name = $("#easyorder-popup-holder").find("input[type=text]")[0].value;
  var address = $("#easyorder-popup-holder").find("input[type=text]")[1].value;
  var city = $("#easyorder-popup-holder").find("input[type=text]")[2].value;
  var price = $(".easyorder-item-price-price")[0].textContent.split(" dh").join("");
  var product = $(".product-single__title")[0].textContent;

 
  if(!isNaN(phone)&&phone.length==9&&(phone.startsWith("6")||phone.startsWith("7"))){
    
     $.ajax({
            url: "https://ghizlane.net/site-order",
            type: "POST",
            dataType: 'jsonp',
            data: {
                name,
                address,
                city,
                phone,
                price,
                product,
            },
            success: function (data) {
//               fbq('track', 'Purchase');
//                 console.log(data)
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(thrownError)
            }
        });
 
  }else{
   console.log("nop");
  }
}

function click_cart(){
document.getElementById("AddToCart-product-template").click();
}


function isScrolledIntoView(el) {
 
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    return isVisible;
}

window.addEventListener('scroll', function() {
  
  if(this.document.getElementById("start-true")==null)
    return;
    var bool = isScrolledIntoView(this.document.getElementById("start-true"))||isScrolledIntoView(this.document.getElementById("end-true"));
        this.document.getElementById("blank-btn").hidden = bool;
    
  });